import {FuseRouteItemType} from '@fuse/utils/FuseUtils';

import KidCreatedPage from './KidCreatedPage';

const CreatingKidPageRoute: FuseRouteItemType = {
  path: '',
  element: <KidCreatedPage />,
};

export default CreatingKidPageRoute;
